import { notification } from 'antd'

import { NOTIFICATION_PLACEMENT } from '@app/constants/notification'

import type {
  NotificationService,
  Notification,
  AntdNotificationApi,
  NotificationData,
  NotificationPlacement
} from './types'

const DEFAULT_PLACEMENT = NOTIFICATION_PLACEMENT.bottomRight

export class AntdNotificationService implements NotificationService {
  #antdNotificationApi: AntdNotificationApi

  constructor (antdNotificationApi: AntdNotificationApi) {
    this.#antdNotificationApi = antdNotificationApi
  }

  open = (config: Notification): void => {
    this.#antdNotificationApi.open({
      ...config,
      placement: config.placement ?? DEFAULT_PLACEMENT
    })
  }

  success = (notificationData: NotificationData, placement?: NotificationPlacement): void => {
    this.#antdNotificationApi.success({
      ...notificationData,
      placement: placement ?? DEFAULT_PLACEMENT
    })
  }

  info = (notificationData: NotificationData, placement?: NotificationPlacement): void => {
    this.#antdNotificationApi.info({
      ...notificationData,
      placement: placement ?? DEFAULT_PLACEMENT
    })
  }

  warning = (notificationData: NotificationData, placement?: NotificationPlacement): void => {
    this.#antdNotificationApi.warning({
      ...notificationData,
      placement: placement ?? DEFAULT_PLACEMENT
    })
  }

  error = (notificationData: NotificationData, placement?: NotificationPlacement): void => {
    this.#antdNotificationApi.error({
      ...notificationData,
      placement: placement ?? DEFAULT_PLACEMENT
    })
  }

  closeOne = (key: string): void => {
    this.#antdNotificationApi.destroy(key)
  }

  closeAll = (): void => {
    this.#antdNotificationApi.destroy()
  }
}

const antdNotificationService = new AntdNotificationService(notification)

export default antdNotificationService
